export default __webpack_public_path__ + "static/media/arrowRight.a3ddc267.svg";